import {
  getThumbnailPreviewImage,
  type ExercisePreviewImageResult,
  type ExerciseThumbnail,
} from "utils";

interface ExerciseValue {
  id: string;
  name: string;
  thumbnail: ExerciseThumbnail;
}

export function getExercisePreviewImage(
  exercise: ExerciseValue,
): ExercisePreviewImageResult {
  return getThumbnailPreviewImage(exercise.thumbnail);
}
